(function () {

    'use strict';

    angular
        .module('app.common')
        .filter('trustAsResourceUrl', ['$sce', function ($sce) {
            return $sce.trustAsResourceUrl;
        }]);

})();


// WEBPACK FOOTER //
// ./app/common/filter/trustAsResourceUrlFilter.js